import React from 'react';
import { HistoryDrawer } from '../History';
import LoginDialog from '../Auth/LoginDialog';
import { DeleteDialog, ErrorModal, GlobalCopyProgressModal } from '../Modal';
import { LoadingSpinner } from '../common';
import { useTranslation } from 'react-i18next';

const LandingModals = ({
  // Auth related
  isLoggedIn,
  userId,
  loginDialogOpen,
  setLoginDialogOpen,
  email,
  setEmail,
  password,
  setPassword,
  isSignup,
  setIsSignup,
  handleEmailAuth,
  handleGoogleAuth,
  handleKakaoAuth,
  authLoading,
  // Analysis related
  analyzeLoading,
  pendingAnalysis,
  setPendingAnalysis,
  // History related
  drawerOpen,
  setDrawerOpen,
  history,
  setHistory,
  getSelectedHistoryId,
  handleSelectHistory,
  editingHistoryId,
  setEditingHistoryId,
  editingTitle,
  setEditingTitle,
  handleEditHistory,
  handleDeleteClick,
  setAnalyzedVideoId,
  setAnalyzedTitle,
  setAnalyzedUrl,
  // Delete dialog
  deleteDialogOpen,
  setDeleteDialogOpen,
  handleDeleteConfirm,
  deleteTargetId,
  // Error modal
  errorModalOpen,
  closeErrorModal,
  errorType,
  handleRetry,
  errorMessage,
  // Global copy modal
  globalCopyModal,
  handleGlobalCopyComplete
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* History Drawer */}
      {isLoggedIn && (
        <HistoryDrawer
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          history={history}
          setHistory={setHistory}
          selectedHistoryId={getSelectedHistoryId()}
          setSelectedHistoryId={handleSelectHistory}
          editingHistoryId={editingHistoryId}
          setEditingHistoryId={setEditingHistoryId}
          editingTitle={editingTitle}
          setEditingTitle={setEditingTitle}
          handleEditHistory={handleEditHistory}
          handleDeleteClick={handleDeleteClick}
          setAnalyzedVideoId={setAnalyzedVideoId}
          setAnalyzedTitle={setAnalyzedTitle}
          setAnalyzedUrl={setAnalyzedUrl}
          userId={userId}
        />
      )}

      {/* Login Dialog */}
      <LoginDialog
        open={loginDialogOpen}
        onClose={() => {
          setLoginDialogOpen(false);
          setPendingAnalysis(false);  // 로그인 취소 시 pending 상태 초기화
          // 모달 초기화는 LoginDialog 내부에서 처리됨
        }}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        isSignup={isSignup}
        setIsSignup={setIsSignup}
        handleEmailAuth={handleEmailAuth}
        handleGoogleAuth={handleGoogleAuth}
        handleKakaoAuth={handleKakaoAuth}
      />

      {/* Loading Spinners - authLoading은 LandingLayout에서 처리하므로 제거 */}
      {/* <LoadingSpinner 
        open={authLoading} 
        message={t('common.processing')} 
      /> */}

      <LoadingSpinner 
        open={analyzeLoading} 
        message={t('common.startingAnalysis')} 
      />

      {/* Delete Dialog */}
      {isLoggedIn && (
        <DeleteDialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onConfirm={handleDeleteConfirm}
          title={history.find(h => h.id === deleteTargetId)?.title || ''}
        />
      )}

      {/* Error Modal */}
      <ErrorModal
        open={errorModalOpen}
        onClose={closeErrorModal}
        errorType={errorType}
        onRetry={handleRetry}
        customMessage={errorMessage}
      />

      {/* Global Copy Progress Modal */}
      <GlobalCopyProgressModal
        open={globalCopyModal.open}
        videoTitle={globalCopyModal.videoTitle}
        onComplete={handleGlobalCopyComplete}
      />
    </>
  );
};

export default LandingModals; 